import React, { useRef } from 'react';

import DataDirect from '../Animations/DataDirect';
import MobileApps from '../Animations/MobileApps';
import ProductAnalytics from '../Animations/ProductAnalytics';
import SessionInsights from '../Animations/SessionInsights';
import ContentfulImage from './ContentfulImage';
import RichTextConverter from './RichText/RichTextConverter';
import * as styles from './ScrollAnimation.module.scss';

export default function ScrollAnimation({ section }) {
  const containerRef = useRef();
  let animation;

  switch (section.animationType) {
    case 'Data Direct':
      animation = <DataDirect containerRef={containerRef} content={section.content} />;
      break;

    case 'Mobile Apps':
      animation = <MobileApps containerRef={containerRef} />;
      break;

    case 'Product Analytics':
      animation = <ProductAnalytics containerRef={containerRef} />;
      break;

    case 'Session Insights':
      animation = <SessionInsights containerRef={containerRef} />;
      break;

    default:
      break;
  }

  return (
    <section ref={containerRef} className={styles.scrollAnimation} data-analytics-section={'scrolling-animation'}>
      <div className={styles.columns}>
        <div className={styles.features}>
          {section.content.map((feature, i) => (
            <div
              key={i}
              className={styles.feature}
              data-analytics-component={'animated-feature-block'}
              data-analytics-id={feature.title}
            >
              {feature.image && (
                <div className={styles.image}>
                  <ContentfulImage lazy={true} imageFragment={feature.image} />
                </div>
              )}
              <h2>{feature.title}</h2>
              {feature.subtitle && <h3>{feature.subtitle}</h3>}
              <RichTextConverter copy={feature.body} />
            </div>
          ))}
        </div>
        <div className={styles.anchoredAnimation}>{animation}</div>
      </div>
    </section>
  );
}
